import {
    IWorkflowNode,
    resourceNameWorkflowNode,
} from "motw_core/Entity/IWorkflowNode";
import {
    todayNodeName,
    workflowRepository,
} from "motw_core/Repositories/WorkflowRepository";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { defaultMemoryBoxNumber } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Helpers/defaultMemoryBoxNumber";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { AwardBookOfMindPointAsync } from "source/app/services/Workflows/Helpers/AwardBookOfMindPoint";
import { TouchWorkflowNodeParentsAsync } from "./TouchWorkflowNodeParentsAsync";

export async function AddNodeAsync(node: Partial<IWorkflowNode>) {
    const maxNodeId: number = await WithAnimatedProgressBarAsync(() =>
        workflowRepository.GetMaxNodeId(ClientDataProvider)
    );

    const newNode = {
        id: maxNodeId + 1,
        ...node,
        memorybox: node.memorybox ?? defaultMemoryBoxNumber,
    } as IWorkflowNode;

    const workflows = GetWorkflowsState();
    const visibleNodes = workflows.state.visibleNodes;
    visibleNodes.push(newNode);

    const todayNode = await workflowRepository.GetNodeByNameAsync(
        ClientDataProvider,
        todayNodeName
    );

    const todayNodes =
        todayNode && newNode.parentid === todayNode.id
            ? [...workflows.state.todayNodes, newNode]
            : workflows.state.todayNodes;

    workflows.setState({ visibleNodes, todayNodes });

    await ClientDataProvider.AddRecordAsync(resourceNameWorkflowNode, newNode);
    await TouchWorkflowNodeParentsAsync([newNode.parentid]);
    AwardBookOfMindPointAsync(newNode); // no need to await this
}
